import { useState } from 'react'
import { Building2, ChevronDown, Loader2 } from 'lucide-react'
import { useAuth } from '@/lib/auth/AuthProvider'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export function TenantSwitcher() {
  const { user, switchTenant } = useAuth()
  const [isLoading, setIsLoading] = useState(false)

  if (!user?.available_tenants || user.available_tenants.length <= 1) {
    return null
  }

  const currentTenant = user.available_tenants.find(
    t => t.tenant_id === user.tenant_id
  )

  const handleSwitch = async (tenantId: string) => {
    if (tenantId === user.tenant_id) return
    setIsLoading(true)
    try {
      await switchTenant(tenantId)
      // Page reloads after successful switch
    } catch (error) {
      console.error('Failed to switch tenant:', error)
      setIsLoading(false)
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="w-full justify-start gap-2 px-3 h-9"
          disabled={isLoading}
        >
          {isLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Building2 className="h-4 w-4" />
          )}
          <span className="flex-1 truncate text-sm text-left">
            {currentTenant?.name || user.tenant_id.replace(/_/g, ' ')}
          </span>
          <ChevronDown className="h-3 w-3 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        {user.available_tenants.map(tenant => (
          <DropdownMenuItem
            key={tenant.tenant_id}
            onClick={() => handleSwitch(tenant.tenant_id)}
            className={tenant.tenant_id === user.tenant_id ? 'bg-accent' : ''}
            disabled={isLoading}
          >
            <span className="flex-1">{tenant.name}</span>
            {tenant.tenant_id === user.tenant_id && (
              <span className="ml-2 text-xs text-muted-foreground">current</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
